/**
 * iOS Safari often keeps gallery/camera `File`s as lazy references and can
 * revoke them after the picker closes, the input is cleared, or the tab is
 * briefly backgrounded — FormData then uploads 0 bytes.
 *
 * Read bytes into the JS heap immediately so later normalize/upload is safe.
 */
export async function materializePickerFile(file: File): Promise<File> {
  const buffer = await file.arrayBuffer();
  const name = file.name?.trim() || 'image.jpg';
  const type = (file.type || '').trim();
  return new File([buffer], name, {
    type,
    lastModified: file.lastModified || Date.now(),
  });
}
